// Dependencies
import { h, Component } from 'preact';

// Components
import {I18n, CreditCardIcon, CreditCardNumber} from 'components/elements'

// Styles
import style from './style'

// Component
export default (props)=>{
    console.log({props});
    return (
    <div class={style.card} onClick={props.onClick}>
        <div className={style.cardContent}>
            <div class={style.cardName}>{props.card.name}</div>
            <div class={style.cardNumber}>
                <CreditCardNumber cardNumber={props.card.cardNumber} />
            </div>
            <div class={style.expires}>
                <I18n>expires</I18n>: {props.card.expMonth}/{props.card.expYear}
            </div>
        </div>
        <CreditCardIcon type={props.card.cardType} class={style.cardIcon} />
    </div>

)}


// WEBPACK FOOTER //
// ./components/groups/CreditCard/index.js